import { FC } from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const DocumentIcon: FC<IconProps> = ({ ...rest }) => {
  return (
    <Icon viewBox="0 0 40 40" bg="#eeeeef" height="10" width="8" {...rest}>
      <path
        d="M13 15.505a.5.5 0 0 1 .498-.505h13.004c.275 0 .498.214.498.505v.99a.5.5 0 0 1-.498.505H13.498a.494.494 0 0 1-.498-.505v-.99zm0 4a.5.5 0 0 1 .498-.505h13.004c.275 0 .498.214.498.505v.99a.5.5 0 0 1-.498.505H13.498a.494.494 0 0 1-.498-.505v-.99zm0 4c0-.279.233-.505.503-.505h5.994c.278 0 .503.214.503.505v.99a.509.509 0 0 1-.503.505h-5.994a.497.497 0 0 1-.503-.505v-.99z"
        fill="#637282"
      />
    </Icon>
  );
};
